<div class="card velocity" [ngClass]="{'hand': clickable }" (click)="openChartModal()">
	<p class="card-title">{{ title }}</p>
	<div class="circle">
      <p>{{ fraction  | percent }}</p>
      <app-radial-progress [value]="fraction"></app-radial-progress>
	</div>
</div>
